import { Reducer } from 'redux'

import {
  LIKE_PHOTO_NEXT,
  LIKE_PHOTO_PROFILE_NEXT,
  likePhotoNextPlainAction,
  likePhotoNextProfilePlainAction,
} from 'actions/rating/likePhotoNextAction'
import { CLEAR_MATCH, clearMatchAction } from 'actions/rating/matchAction'
import { definitions } from 'api/generated/ratings_v2.voting'
import { defaultPromiseReducer } from 'reducers/defaultPromiseReducer'

export interface MatchState {
  initiator: definitions['RatingVotingPhotoOwner'] | null
  initiatorPhotoId: number | null
  initiatorPhotoUrls: definitions['PhotoUrls'] | null
  matcherPhotoId: number | null
  matcherPhotoUrls?: definitions['PhotoUrls'] | null
  counter: number
}

const initialState: MatchState = {
  initiator: null,
  initiatorPhotoId: null,
  initiatorPhotoUrls: null,
  matcherPhotoId: null,
  matcherPhotoUrls: null,
  counter: 0,
}

export const matchReducer: Reducer<
  MatchState,
  | ReturnType<typeof likePhotoNextPlainAction>
  | ReturnType<typeof likePhotoNextProfilePlainAction>
  | ReturnType<typeof clearMatchAction>
> = (state = initialState, action) => {
  switch (action.type) {
    case LIKE_PHOTO_NEXT:
    case LIKE_PHOTO_PROFILE_NEXT:
      return defaultPromiseReducer(state, action, undefined, ({ match }) => {
        if (match) {
          return {
            initiator: match.initiator,
            initiatorPhotoId: match.initiatorPhotoId,
            initiatorPhotoUrls: match.initiatorPhotoUrls,
            matcherPhotoId: match.matcherPhotoId,
            matcherPhotoUrls: match.matcherPhotoUrls,
            counter: state.counter >= 4 ? 1 : state.counter + 1,
          }
        }

        return state
      })

    case CLEAR_MATCH:
      return { ...initialState, counter: state.counter }

    default:
      return state
  }
}
